import React from 'react';
import { ToastContext, Dropdown } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../context/useAppContext';
import SessionModel from '../../../models/sessionModel';
import PropTypes from 'prop-types';

export function StatusAction({ objects: selectedSessions, sessionDetail = false, action = 'enable', onSave = () => {} }) {
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();
    const [{ event, organization }] = useAppContext();

    const itemsFiltered = React.useMemo(() => {
        if (!selectedSessions) {
            return [];
        }
        return selectedSessions.filter(s => (action === 'enable' ? !s.enabled : s.enabled));
    }, [selectedSessions]);

    const handleSubmit = React.useCallback(() => {
        SessionModel.perform_action(action, itemsFiltered, { organization, event })
            .then(() => {
                toast.success(t(`ticket.sessions.actions.${action}.success`, { count: itemsFiltered.length }));
                onSave();
            })
            .catch(e => {
                console.error(e);
                toast.error(t(`ticket.sessions.actions.${action}.error`, { count: itemsFiltered.length }));
            });
    }, [event, organization, SessionModel, toast, onSave]);

    return (
        <Dropdown.Item disabled={!itemsFiltered.length} onClick={handleSubmit}>
            {t(`ticket.sessions.actions.${action}.label`, { count: sessionDetail ? 1 : 2 })}
        </Dropdown.Item>
    );
}

StatusAction.propTypes = {
    objects: PropTypes.array, //required
    action: PropTypes.string,
    onSave: PropTypes.func,
    sessionDetail: PropTypes.bool
};
